import type { UserDto } from '@mathflat/domain/@entities/User'

import maxios from '@/utils/axios/maxios'

const userApi = {
  getMe(): ReturnType<typeof maxios.get<UserDto.MeResponseDto>> {
    return maxios.get<UserDto.MeResponseDto>('/users/me')
  },
}

export default userApi
